import { connect } from 'react-redux'
import { isMobileOnly } from 'react-device-detect'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import StoriesHeader from './StoriesHeader'
import { proTrackList, setProtrackId } from 'store/entities/stories/actions'
import {
  getStoriesProTrackId,
  getStoriesProTrackOptionsIds,
  getStoriesProTrackOptionsLabels,
} from 'store/entities/stories/selectors'

const mapStateToProps = state => ({
  ids: getStoriesProTrackOptionsIds(state),
  labels: getStoriesProTrackOptionsLabels(state),
  value: getStoriesProTrackId(state),
  isMobileOnly,
})

const mapDispatchToProps = {
  onRequest: proTrackList.get.request,
  onChange: setProtrackId,
}

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(StoriesHeader))
